/***
 * Created on 2025/11/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalComponent from "../common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import TableComponent from "../common/TableComponent/TableComponent";
import UserAvatarIcon from "../common/UserAvatarIcon";
import {normalizeSpaceSize} from "../../service/utils";
import {formatDateTime, getTimeWithTimezone} from "../../service/timezone";

function RemovedUserUsageRowComponent({row_data, index, show_checkbox=false, disPatcher, table_head_fields, translate:t}) {
    return (
        <div className="flexbox-trow">
            <div className="tbody-cell w-44">
                <div className="admin-info">
                    <UserAvatarIcon user_info={row_data} with_user_info={true}/>
                </div>
            </div>
            <div className="tbody-cell w-28">
                {
                    normalizeSpaceSize(row_data.quota_usages.reduce((total, usage) => total + usage.usage, 0))
                }
            </div>
            <div className="tbody-cell w-28">{getTimeWithTimezone(row_data.removed_at, false)}</div>
        </div>
    );
}

function CloudSpaceRemovedUserUsageModal({ isOpen, onClose, user_data }) {
    console.log("CloudSpaceRemovedUserUsageModal user_data:", user_data);
    const { t } = useTranslation();

    const table_head_fields = [
        {field_name: t('@Deleted Member@'), isSortable: true, width_style: '!w-44', field_id: 'display_name', default_sort: true, default_sort_order: ''},
        {field_name: t('@Used Space@'), isSortable: false, width_style: '!w-28'},
        {field_name: t('@Deleted Date@'), isSortable: false, width_style: '!w-28'}
    ];

    return (
        <ModalComponent isOpen={isOpen} onClose={onClose} showSubmit={false} closeText={t('@Close@')} title={t("@Deleted Members Space Usage@")} cancelText={t("@Close@")}>
            <div className="dialog-content">
                 <div className="text-wrap">
                     {t('@Space used by files uploaded by removed members.@')}
                </div>
                <TableComponent
                    table_head_fields={table_head_fields}
                    table_data={{data: user_data}}
                    table_ui={null}
                    search={false}
                    row_component={RemovedUserUsageRowComponent}
                    // state={null}
                    data_table_name="cloud-space-removed-user-usage"
                    pagination={false}
                    table_height={'335px'}
                />
            </div>
        </ModalComponent>
    );
}

export default CloudSpaceRemovedUserUsageModal;